import LabServiceModel from "@/models/LabServiceModel";
import TestPackageSampleModel from "@/models/lab/TestPackageSampleModel";
import AnalyteModel from "./AnalyteModel";

export default class TestPackageAnalyteModel extends LabServiceModel {
  modelName() {
    return "test-package-analyte";
  }
  defaults() {
    return {
      id: null,
      test_package_sample_id: null,
      analyte_id: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      test_package_sample: null,
      analyte: null
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      test_package_sample_id: val => this.nullStringMutator(val),
      analyte_id: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
  getTestPackageSample() {
    return this.getRelatedModel(TestPackageSampleModel, "test_package_sample");
  }
  getAnalyte() {
    return this.getRelatedModel(AnalyteModel, "analyte");
  }
}
